(function () {
  'use strict';

  function setActiveThumb(thumbs, activeThumb) {
    thumbs.forEach(function (t) {
      t.classList.remove('pdp__thumb--active');
      t.setAttribute('aria-current', 'false');
    });
    activeThumb.classList.add('pdp__thumb--active');
    activeThumb.setAttribute('aria-current', 'true');
  }

  function swapMainImage(mainImg, thumb) {
    var src = thumb.getAttribute('data-img-src');
    var srcset = thumb.getAttribute('data-img-srcset');
    var alt = thumb.getAttribute('data-img-alt');
    if (!src) return;

    mainImg.classList.add('is-fading');
    window.setTimeout(function () {
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      if (alt) mainImg.alt = alt;
      mainImg.classList.remove('is-fading');
    }, 120);
  }

  function initPdpThumbNav(root) {
    var nav = root.querySelector('[data-pdp-thumbs-nav]');
    var thumbsEl = root.querySelector('[data-pdp-thumbs]');
    var btnUp = root.querySelector('[data-pdp-thumbs-up]');
    var btnDown = root.querySelector('[data-pdp-thumbs-down]');
    if (!nav || !thumbsEl || !btnUp || !btnDown) return;

    function scrollStep(direction) {
      var thumb = thumbsEl.querySelector('.pdp__thumb');
      if (!thumb) return;
      var gap = 10;
      var step = thumb.offsetHeight + gap;
      thumbsEl.scrollBy({
        top: direction * step,
        behavior: 'smooth'
      });
    }

    function updateArrows() {
      var maxScroll = thumbsEl.scrollHeight - thumbsEl.clientHeight;
      var scrollTop = thumbsEl.scrollTop;
      btnUp.disabled = scrollTop <= 2;
      btnDown.disabled = scrollTop >= maxScroll - 2;
    }

    btnUp.addEventListener('click', function () {
      scrollStep(-1);
    });

    btnDown.addEventListener('click', function () {
      scrollStep(1);
    });

    thumbsEl.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initPdpGallery(root) {
    var mainImg = root.querySelector('[data-pdp-hero]');
    var thumbs = root.querySelectorAll('[data-pdp-thumb]');
    var thumbsEl = root.querySelector('[data-pdp-thumbs]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        swapMainImage(mainImg, thumb);
        setActiveThumb(thumbs, thumb);

        if (thumbsEl && window.matchMedia('(min-width: 990px)').matches) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });

    initPdpThumbNav(root);
    initPdpZoom(root);
  }

  function initPdpZoom(root) {
    var frame = root.querySelector('[data-pdp-main-img]');
    var img = root.querySelector('[data-pdp-hero]');
    if (!frame || !img) return;

    function setOrigin(e) {
      var rect = frame.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin =
        Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
    }

    frame.addEventListener('click', function (e) {
      var zoomed = frame.classList.toggle('is-zoomed');
      if (zoomed) setOrigin(e);
      else img.style.transformOrigin = '';
    });

    frame.addEventListener('mousemove', function (e) {
      if (frame.classList.contains('is-zoomed')) setOrigin(e);
    });

    frame.addEventListener('mouseleave', function () {
      frame.classList.remove('is-zoomed');
      img.style.transformOrigin = '';
    });
  }

  function initPdpQty(root) {
    var input = root.querySelector('[data-qty-input]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val - 1);
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        var max = parseInt(input.getAttribute('max'), 10) || 20;
        input.value = Math.min(max, val + 1);
      });
    }
  }

  function normalizeOptionValue(value) {
    return String(value == null ? '' : value).trim();
  }

  function variantOptions(v) {
    var opts = [];
    if (v.option1 != null && v.option1 !== '') opts.push(normalizeOptionValue(v.option1));
    if (v.option2 != null && v.option2 !== '') opts.push(normalizeOptionValue(v.option2));
    if (v.option3 != null && v.option3 !== '') opts.push(normalizeOptionValue(v.option3));
    if (!opts.length && v.options && v.options.length) {
      v.options.forEach(function (o) {
        var val = normalizeOptionValue(o);
        if (val) opts.push(val);
      });
    }
    return opts;
  }

  function optionsMatchSelection(vOpts, selected) {
    if (!selected.length || !vOpts.length) return false;
    if (vOpts.length !== selected.length) return false;
    for (var i = 0; i < selected.length; i++) {
      if (normalizeOptionValue(vOpts[i]) !== normalizeOptionValue(selected[i])) return false;
    }
    return true;
  }

  function findVariantForSelection(variants, selected) {
    if (!selected.length) return null;
    return variants.find(function (v) {
      return optionsMatchSelection(variantOptions(v), selected);
    }) || null;
  }

  function getSelectedOptionsFromForm(form) {
    var selected = [];
    form.querySelectorAll('.pdp__option').forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked:not(:disabled)');
      if (checked) selected.push(normalizeOptionValue(checked.value));
    });
    if (!selected.length) {
      var maxIndex = -1;
      form.querySelectorAll('[data-option-index]:checked').forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        if (isNaN(idx)) return;
        selected[idx] = normalizeOptionValue(input.value);
        if (idx > maxIndex) maxIndex = idx;
      });
      if (maxIndex >= 0) {
        var dense = [];
        for (var i = 0; i <= maxIndex; i++) dense[i] = selected[i] || '';
        selected = dense;
      }
    }
    return selected;
  }

  function initPdpVariants(root) {
    var form = root.querySelector('[data-pakhor-add]');
    var variantInput = form.querySelector('[data-variant-id], [name="id"]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var atcBtn = root.querySelector('[data-pdp-atc]');
    var variantsJson = root.querySelector('[data-pdp-variants]');
    if (!form || !variantInput || !variantsJson) return;

    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }

    var optionInputs = form.querySelectorAll('[data-option-index]');
    if (!optionInputs.length) return;

    function getSelectedOptions() {
      return getSelectedOptionsFromForm(form);
    }

    function findMatchingVariant(selected) {
      return findVariantForSelection(variants, selected);
    }

    function updateOptionAvailability() {
      var selected = getSelectedOptions();
      var fieldsets = form.querySelectorAll('.pdp__option');

      fieldsets.forEach(function (fieldset, fieldsetIndex) {
        fieldset.querySelectorAll('[data-option-index]').forEach(function (input) {
          var optionIndex = fieldsetIndex;
          var val = normalizeOptionValue(input.value);
          var available = variants.some(function (v) {
            if (!v.available) return false;
            var vOpts = variantOptions(v);
            if (normalizeOptionValue(vOpts[optionIndex]) !== val) return false;
            for (var i = 0; i < vOpts.length; i++) {
              if (i === optionIndex) continue;
              if (selected[i] && normalizeOptionValue(vOpts[i]) !== normalizeOptionValue(selected[i])) {
                return false;
              }
            }
            return true;
          });

          input.disabled = !available;
          var label = input.closest('.pdp__pill');
          if (label) {
            label.classList.toggle('pdp__pill--unavailable', !available);
            if (!available) {
              label.setAttribute('title', 'Out of Stock');
              label.setAttribute('aria-label', val + ': Out of Stock');
            } else {
              label.removeAttribute('title');
              label.removeAttribute('aria-label');
            }
          }

          if (!available && input.checked) input.checked = false;
        });
      });

      fieldsets.forEach(function (fieldset) {
        if (fieldset.querySelector('input[type="radio"]:checked:not(:disabled)')) return;
        var firstAvailable = fieldset.querySelector('input[type="radio"]:not(:disabled)');
        if (firstAvailable) firstAvailable.checked = true;
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      return (cents / 100).toFixed(2);
    }

    function updateVariant() {
      updateOptionAvailability();
      var selected = getSelectedOptions();
      var match = findMatchingVariant(selected);

      if (!match) return;

      variantInput.value = String(match.id);

      if (atcBtn) {
        atcBtn.disabled = !match.available;
        if (!match.available) {
          atcBtn.textContent = 'Sold out';
        } else if (atcBtn.dataset.atcLabel) {
          atcBtn.textContent = atcBtn.dataset.atcLabel;
        }
      }

      if (priceEl) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html +=
            '<span class="pdp__price-compare">' +
            formatMoney(match.compare_at_price) +
            '</span>';
          html +=
            '<span class="pdp__price-now pdp__price-now--sale">' +
            formatMoney(match.price) +
            '</span>';
        } else {
          html += '<span class="pdp__price-now">' + formatMoney(match.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }

      var heroImg = root.querySelector('[data-pdp-hero]');
      if (match.featured_image && heroImg) {
        heroImg.classList.add('is-fading');
        window.setTimeout(function () {
          heroImg.src =
            match.featured_image.src.replace(/(\._.*)?\.(jpg|jpeg|png|webp)/i, '_1200x.$2') ||
            match.featured_image.src;
          heroImg.classList.remove('is-fading');
        }, 120);
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.disabled) {
          input.checked = false;
          return;
        }
        updateVariant();
      });
    });

    form.addEventListener('click', function (e) {
      var pill = e.target.closest('.pdp__pill');
      if (!pill) return;
      if (pill.classList.contains('pdp__pill--unavailable')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      window.setTimeout(updateVariant, 0);
    });

    updateVariant();

    if (!window.PakhorPdp) window.PakhorPdp = {};
    if (!window.PakhorPdp._roots) window.PakhorPdp._roots = [];

    window.PakhorPdp._roots.push({
      root: root,
      form: form,
      getVariantId: function () {
        var selected = getSelectedOptions();
        var match = findMatchingVariant(selected);
        if (match) {
          variantInput.value = String(match.id);
          return variantInput.value;
        }
        return variantInput.value;
      }
    });

    window.PakhorPdp.syncVariant = function (scope) {
      var target = scope;
      if (target && !target.matches && target.querySelector) {
        target = target.closest ? target.closest('[data-pdp-root]') : null;
      }
      if (target && target.matches && !target.matches('[data-pdp-root]')) {
        target = target.closest('[data-pdp-root]');
      }
      (window.PakhorPdp._roots || []).forEach(function (entry) {
        if (!target || entry.root === target) entry.getVariantId();
      });
    };

    window.PakhorPdp.getVariantId = function (scope) {
      var target = scope && scope.closest ? scope.closest('[data-pdp-root]') : document.querySelector('[data-pdp-root]');
      var entry = (window.PakhorPdp._roots || []).find(function (e) {
        return !target || e.root === target;
      });
      return entry ? entry.getVariantId() : null;
    };
  }

  /* Add-to-cart is owned exclusively by pakhor-cart.js (single cart
     controller). product-page.js only handles gallery, qty stepper UI,
     and variant switching to avoid duplicate add-to-cart requests. */

  function initPdp(root) {
    if (!root || root.dataset.pdpInit) return;
    root.dataset.pdpInit = 'true';
    initPdpGallery(root);
    initPdpQty(root);
    initPdpVariants(root);
  }

  function boot() {
    document.querySelectorAll('[data-pdp-root]').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
